import { render, staticRenderFns } from "./DIsableISVLocation.vue?vue&type=template&id=479f9f26&"
import script from "./DIsableISVLocation.vue?vue&type=script&lang=js&"
export * from "./DIsableISVLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports